<template>
  <v-list-item
    link
    @click="openViewerWeb"
    :disabled="sending"
    :dense="small"
    v-if="$utilFront.withPermission($prm.VIEWER_WEB_INT)"
  >
    <v-list-item-icon>
      <v-icon color="primary" :small="small">mdi-eye</v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title>
        <span>Ver imágenes</span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import StudyRequest from "@/core/request/StudyRequest";

export default {
  name: "ViewImageIntItem",
  props: {
    send: Function,
    sending: Boolean,
    small: Boolean,
    idStudy: String,
  },
  methods: {
    openViewerWeb() {
      this.send();

      StudyRequest.generateLinkToViewImages(this.idStudy)
        .then((response) => {
          let { data, code } = response.data;
          if (code == 200) window.open(data, "_blank");
          else this.$utilFront.notifications("Error de conexión al servidor de imágenes", "ERROR");
        })
        .catch((e) => this.$utilFront.errorhttp(e))
        .finally(() => {
          this.send();
        });
    },
  },
};
</script>
